/** Notification settings: config helpers (pure, no React). */

export const SOURCE_LABEL = {
  OWN: { label: "Company setting", tone: "blue" },
  INHERITED: { label: "Inherited", tone: "gray" },
  GLOBAL: { label: "Global default", tone: "gray" },
  DEFAULT: { label: "Built-in default", tone: "gray" },
};

export const RECIPIENT_LABEL = {
  HR: "HR",
  BRANCH_MANAGER: "Branch manager",
};

const GROUP_ORDER = ["Approvals", "Results", "HR alerts"];

/** A type missing from config.types counts as on. */
export const isEnabled = (config, type) =>
  config?.types?.[type]?.enabled !== false;

export const setEnabled = (config, type, enabled) => ({
  ...config,
  types: { ...(config?.types || {}), [type]: { enabled } },
});

/** Catalog types → [{ group, types }] in a fixed group order; PROBATION has its own block. */
export const groupTypes = (types = []) => {
  const groups = new Map();
  types
    .filter((t) => t.type !== "PROBATION")
    .forEach((t) => {
      const g = t.group || "Other";
      if (!groups.has(g)) groups.set(g, []);
      groups.get(g).push(t);
    });
  const rank = (g) => {
    const i = GROUP_ORDER.indexOf(g);
    return i === -1 ? GROUP_ORDER.length : i;
  };
  return [...groups.entries()]
    .sort(([a], [b]) => rank(a) - rank(b))
    .map(([group, list]) => ({ group, types: list }));
};

export const toggleIn = (list = [], value) =>
  list.includes(value)
    ? list.filter((v) => v !== value)
    : [...list, value].sort((a, b) => (a > b ? 1 : a < b ? -1 : 0));

/** Browser-side checks (the server validates too). */
export const probationProblems = (probation) => {
  if (!probation?.enabled) return [];
  const p = [];
  if (!(probation.months || []).length)
    p.push("Probation alerts: pick at least one month.");
  const d = Number(probation.daysBefore);
  if (!Number.isInteger(d) || d < 0 || d > 60)
    p.push("Probation alerts: days before must be 0 to 60.");
  if (!(probation.recipients || []).length)
    p.push("Probation alerts: pick who receives them.");
  return p;
};

/** Config to send: daysBefore as a number. */
export const toPayload = (config) => ({
  ...config,
  probation: config.probation
    ? { ...config.probation, daysBefore: Number(config.probation.daysBefore) }
    : config.probation,
});
